import React from "react";
import { Tooltip, Typography } from "antd";
import _ from "lodash";
import IconAward from "../assets/images/ic_award.svg";
import { getStaticAssetPath } from "../utils/utils";

const DefaultBadge = "images/ic_award.svg";

const { Paragraph } = Typography;

interface Props {
  awardList: any[];
  mode: number;
  PreviewMode: any;
}

type AwardLogoConfig = {
  match: (item: any) => boolean;
  src: string;
  alt: string;
  width?: string;
};

const awardLogos: AwardLogoConfig[] = [
  {
    match: (item) => item?.title?.includes("Redken Safe Space Educated"),
    src: "redken.png",
    alt: "Redken Award",
    width: "100px",
  },
  {
    match: (item) => item?.title?.includes("Head UP Mental Health - Boundaries"),
    src: "badges/Boundaries-webinar-badge.png",
    alt: "Boundaries",
    width: "150px",
  },
  {
    match: (item) => item?.title?.includes("Head UP Mental Health - Inspiration"),
    src: "badges/Inspiration-webinar-badge.png",
    alt: "Inspiration",
    width: "150px",
  },
  {
    match: (item) => item?.title?.includes("Head UP Mental Health - Confidence"),
    src: "badges/Confidence-webinar-badge.png",
    alt: "Confidence",
    width: "150px",
  },
  {
    match: (item) => item?.title?.includes("Head UP Mental Health - Energy"),
    src: "badges/Energy-webinar-badge.png",
    alt: "Energy",
    width: "150px",
  },
  {
    match: (item) => item?.title?.includes("NAMI Head Up Completion"),
    src: "heads-up-badge.png",
    alt: "Head Up Completion",
    width: "200px",
  },
  {
    match: (item) => item?.title?.includes("Purpose Discovery"),
    src: "badges/beautista-purpose-driven-pro-eq-101.png",
    alt: "Purpose Discovery",
    width: "100px",
  },
  {
    match: (item) => item?.title === "Beacon" && item?.issueYear === "2024",
    src: "badges/pba-beacon-badge-2024.png",
    alt: "Beacon 2024",
    width: "100px",
  },
  {
    match: (item) => item?.title === "Beacon" && item?.issueYear === "2025",
    src: "badges/pba-beacon-badge-2025.png",
    alt: "Beacon 2025",
    width: "100px",
  },
  {
    match: (item) => item?.title?.includes("Biolage"),
    src: "biolage.svg",
    alt: "Biolage",
    width: "100px",
  },
  {
    match: (item) => item?.issuer?.includes("Paul Mitchell"),
    src: "pmts-dark-badge.jpg",
    alt: "PMTS Dark",
    width: "100px",
  },
  {
    match: (item) => item?.issuer?.includes("PMTS"),
    src: "pmts-light-badge.jpg",
    alt: "PMTS Light",
    width: "100px",
  },
  {
    match: (item) => item?.issuer?.includes("PCI Academy"),
    src: "badges/pci-academy.jpg",
    alt: "PCI Academy",
    width: "100px",
  },
  {
    match: (item) => true,
    src: "images/ic_award.svg",
    alt: "Award",
    width: "100px",
  }
];

const getAwardLogo = (item: any) => {
  const config = awardLogos.find((logo) => logo.match(item));
  return (
    <img
      alt={config.alt}
      style={{ width: config.width }}
      src={getStaticAssetPath(config.src)}
    />
  );
};

const getAwardText = (data: any): string => {
  if (typeof data === "number") return "Issue Year - Issuer";
  if (data.issueYear && data.issuer) return `${data.issueYear} - ${data.issuer}`;
  return data.issueYear || data.issuer || "";
};

const getItemText = (item: { title?: string } = {}): string => {
  const title = item.title ?? "Title";
  return title.startsWith("Head UP Mental Health -") ? "Head UP Mental Health" : title;
};

const CanvasAwards: React.FC<Props> = ({ awardList, mode, PreviewMode }) => {
  const isEmpty = _.isEmpty(awardList) && mode !== PreviewMode.CREATE;
  const items = !_.isEmpty(awardList) ? awardList : [0, 1, 2, 3];

  return (
    <div className="awards-sec" hidden={isEmpty} id="awards">
      <span className="canvas-title">Awards and Achievements</span>
      <div className="awards-list">
        {items.map((item, idx) => {
          const isRedken = item?.title?.includes("Redken Safe Space Educated");

          const content = (
            <>
              {getAwardLogo(item)}
              <Tooltip title={getItemText(item)}>
                <Paragraph className="title">{getItemText(item)}</Paragraph>
              </Tooltip>
              <Tooltip title={getAwardText(item)}>
                <Paragraph ellipsis={{ rows: 1, expandable: true }} className="issue">
                  {getAwardText(item)}
                </Paragraph>
              </Tooltip>
            </>
          );

          return (
            <div className="awards-item-empty" key={idx}>
              {isRedken ? (
                <a
                  href="https://u.canvasme.com/course/safe-space/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {content}
                </a>
              ) : (
                content
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CanvasAwards;
